module.exports = __webpack_public_path__ + "img/owl-orange-right.a7deaeef.png";